import { useNavigate } from 'react-router-dom';
import useUserStore from '../../../store/user.store.ts';
import { useEffect } from 'react';
import { UserLandingPageENUM } from '@common/types';

const getUserLandingPage = (userLadingPage: UserLandingPageENUM) => {
  switch (userLadingPage) {
    case UserLandingPageENUM.DASHBOARD:
      return '/dashboard';
    case UserLandingPageENUM.ADMIN_PANEL:
      return '/admin';
    case UserLandingPageENUM.DATA_ANALYSIS:
      return '/data-analysis';
    case UserLandingPageENUM.PATIENTS:
      return '/patient/list';
    case UserLandingPageENUM.REPORTS:
      return '/reporting';
    case UserLandingPageENUM.WORKLIST:
      return '/worklist';
    default:
      return '/worklist';
  }
};

export const LandingPage = () => {
  const navigate = useNavigate();
  const { user } = useUserStore();

  useEffect(() => {
    if (user?.landing_page) {
      navigate(getUserLandingPage(user?.landing_page));
    }
  }, [user]);

  return <div />;
};
